import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, ArrowLeft, CalendarDays } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function VacationsComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="h-20 w-20 rounded-2xl bg-primary/10 flex items-center justify-center">
              <CalendarDays className="h-10 w-10 text-primary" />
            </div>
            <div className="absolute -bottom-1 -right-1 h-7 w-7 rounded-full bg-amber-100 dark:bg-amber-900/40 border-2 border-background flex items-center justify-center">
              <Clock className="h-3.5 w-3.5 text-amber-600 dark:text-amber-400" />
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="space-y-2">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-amber-600 dark:text-amber-400 px-3 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
            Fase 2 — Próximamente
          </span>
          <h1 className="text-2xl font-bold font-heading text-foreground">
            Módulo de Vacaciones
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Estamos preparando este módulo para ti. Muy pronto podrás gestionar
            tus solicitudes de vacaciones directamente desde el portal.
          </p>
          <p className="text-xs text-muted-foreground pt-1">
            Mientras tanto, contacta con RRHH para cualquier gestión de vacaciones.
          </p>
        </div>

        {/* Back button */}
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="gap-2"
          data-testid="btn-back-from-coming-soon"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver
        </Button>
      </div>
    </div>
  );
}
